<section>
	<h1 class="center">
		Lecture
	</h1>
	<nav class="is-mobile">
		<a routerLink="import" routerLinkActive="active-link" *ngIf="canImport()">Import</a>
		<a routerLink="historique" routerLinkActive="active-link">Détail des lectures</a>
		<a routerLink="bilan" routerLinkActive="active-link">Bilan des lectures</a>
	</nav>

	<div class="cab-menu">
		<div class="flex items-center">
			<button mat-icon-button [matMenuTriggerFor]="menu">
				<mat-icon>menu</mat-icon>
			</button>
			<div>{{ title }}</div>
		</div>
		<mat-menu #menu="matMenu">
			<button mat-menu-item routerLink="import" routerLinkActive="active-link" (click)="onChange('Import')">
				<span>Import</span>
			</button>
			<button mat-menu-item routerLink="historique" routerLinkActive="active-link"
				(click)="onChange('Détail des lectures')">
				<span>Détail des lectures</span>
			</button>
			<button mat-menu-item routerLink="bilan" routerLinkActive="active-link"
				(click)="onChange('Bilan des lectures')">
				<span>Bilan des lectures</span>
			</button>
		</mat-menu>

	</div>
</section>
<router-outlet></router-outlet>